var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],ref:"vueIframe",staticStyle:{"border":"none"},attrs:{"src":_vm.src},on:{"load":_vm.onIframeLoad}})
}
var staticRenderFns = []

export { render, staticRenderFns }